import React from 'react';
// import sections
import Testimonial from '../components/servicios/PresenciaOnline';

const PresenciaOnline = () => {

  return (
    <>
    <Testimonial topDivider />
    </>
  );
}

export default PresenciaOnline;